<template>
  <div class="wrap">
    <Navbar :title="$t('晋升')" />
    <div class="list_wrap">
      <div class="">
        <div class="list_item" v-for="(item, index) in activityList" :key="index">
          <div class="img">
            <img :src="item.picture" alt="" />
          </div>
          <div class="cont">
            <div class="cont_top">
              <div class="cont_left">
                <div class="title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="time">
                  {{ `${format(item.indate)}` }}
                </div>
              </div>
              <div class="more" @click="toDetails(index)">{{ $t("查看全部") }}</div>
            </div>
            <div class="conts" v-if="activeIndex === index && item.content">
              <div v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import Tabbar from "../../components/Tabbar.vue";
import { List, Toast } from "vant";
import { $get, $post } from "../../utils/request";
import { format } from "../../utils";
import { mapGetters } from "vuex";
export default {
  components: {
    Tabbar,
    List,
    Toast,
    Navbar
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      currentPage: 1,
      format,
      activeIndex: ''
    };
  },
  computed:{
    ...mapGetters(['activityList'])
  },
  created() {
    // this.getList();
    this.$store.dispatch('getList')
  },
  methods: {
    async getList() {
      this.loading = true;
      if (this.finished) return false;
      this.finished = false;
      if (this.list.length) {
        this.currentPage++;
      }
      try {
        Toast.loading();
        const res = await $get("/content/sale");
        const { ret, msg, data } = res.data;
        this.list = data.lists;
        this.loading = false;
        Toast.clear();
        if (data.currentPage == data.lastPage) {
          this.finished = true;
        }
        // this.configs = data[0];
      } catch (error) {
        Toast.clear();
        this.loading = false;
      }
    },
    toDetails(index) {
      if (index === this.activeIndex) return this.activeIndex = '';
      this.activeIndex = index;
      // const { url } = item.links[0] || {};
      // if (!url) return this.$router.push(`/ActivityDetails?id=${item.id}`);
      // location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
@wrapPadding: calc(12rem / 16);
@comRadius: 4px;
@comBG: linear-gradient(#093958, #022c47);

.wrap {
  @background: var(--black);
  background-color: var(--bg);
  // width: 100vw;
  height: calc(100vh - calc(50rem / 16));
  overflow: scroll;
  position: relative;

  >.title {
    padding: calc(20rem / 16) calc(20rem / 16) 0;
    font-size: calc(24rem / 16);
    font-weight: 600;
    position: sticky;
    background: @background;
    top: 0;
    color: var(--gold);
  }

  .list_wrap {
    padding: calc(10rem / 16);
    padding-top: calc(14rem / 16);

    .list_item {
      margin-bottom: calc(20rem / 16);
      background: var(--navBg);
      border-radius: calc(10rem / 16);
      overflow: hidden;

      .img {
        width: 100%;

        img {
          width: 100%;
          min-height: calc(50rem / 16);
          display: block;
          border-radius: calc(8rem / 16) calc(8rem / 16) 0 0;
        }
      }

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .cont {
        .cont_top {
          padding: calc(15rem / 16) calc(12rem / 16);
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;

          .cont_left {
            display: flex;
            flex-direction: column;

            .title {
              font-size: calc(14rem / 16);
              color: var(--light);
              font-weight: 700;
              line-height: normal;
              width: auto;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              span {
                display: -webkit-box !important;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                white-space: normal;
                line-height: 1.2;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .time {
              font-size: calc(12rem / 16);
              color: var(--light);
              line-height: normal;
            }
          }

          .more {
            display: flex;
            align-items: center;
            height: calc(25rem / 16);
            padding: 0 calc(10rem / 16);
            font-size: calc(12rem / 16);
            font-weight: 700;
            line-height: normal;
            color: var(--light);
            text-align: center;
            background: linear-gradient(180deg,#f4e0b3,#dec17e 50%,#c8a149);
            border-radius: calc(20rem / 16);
            white-space: nowrap;
            box-shadow: inset 0 1px 6.5px 0 #c6c4c4;
          }
        }

        .conts {
          padding: calc(5rem / 16) calc(12rem / 16) calc(25rem / 16);
          color: var(--light);

          /deep/ img {
            width: 100%;
            display: block;
          }
        }
      }
    }
  }
}
</style>